// @ts-ignore
import { QQ } from '@tencent/qcloud-account-lib';
import { Divider, message } from 'antd';
import { isEmpty } from 'lodash-es';
import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import QQIcon from '@/assets/images/login/qq.react.svg?react';
import { getParamFromUrl, toSearchStr } from '@/infrastructure/history';
import { useAuthContext } from '@/presentation/hooks';
import { REDIRECT_URL } from '@/presentation/pages/login/constant';
import styles from '@/presentation/pages/login/index.module.scss';
import { LoginType } from '@/presentation/pages/login/types';
import { useLoginContext } from '@/presentation/pages/login/use-login';
import { authService } from '@/service/auth';
import { RegisterType, tencentCloudService } from '@/service/tencent-cloud';

export const ExtraLogin = () => {
  const history = useHistory();
  const { onLoginSuccess } = useAuthContext();
  const { setLoading } = useLoginContext();
  const redirectURL = encodeURIComponent(getParamFromUrl('url'));
  const qqRef = useRef(new QQ({
    redirectUrl: REDIRECT_URL,
  }));

  const loginWithQQ = () => {
    qqRef.current.openToAuth();
    setLoading(true);
  };

  useEffect(() => {
    qqRef.current.on('recieveAuthCode', async (authInfo: {authCode: string}) => {
      const { authCode } = authInfo;
      const { token, accountList } = await tencentCloudService.preloginForQQ(authCode);

      if (!token) {
        // todo
        setLoading(false);
        return;
      }

      if (isEmpty(accountList)) {
        // 注册流程
        history.push({
          pathname: '/register',
          search: toSearchStr({
            token: token.key as string,
            registerType: RegisterType.QQ,
            url: redirectURL,
          }),
        });
        return;
      }

      if (accountList.length > 1) {
        // 账号切换流程
        history.push({
          pathname: '/select-account',
          state: {
            accountList,
            token,
          },
        });
        return;
      }

      // 调后台登录接口
      const loginRes = await authService.login(LoginType.TencentCloud, {
        saasToken: token.key,
        uin: `${token.uin}` as string,
        ownerUin: `${token.ownerUin}` as string,
      });

      if (loginRes) {
        onLoginSuccess(LoginType.TencentCloud, loginRes?.userInfo, {
          ...token,
          buglyToken: loginRes?.buglyToken,
          saasToken: token.key,
        });
      } else {
        message.error('登录失败，请稍后再试');
      }

      setLoading(false);
    });

    return () => {
      qqRef.current.destory();
    };
  }, []);

  return (
    <div className={styles.extraLogin}>
      <Divider plain className={styles.split}>其他登录方式</Divider>
      <div className={styles.loginType} onClick={loginWithQQ}>
        <QQIcon />
        <span>QQ</span>
      </div>
    </div>
  );
};
